import Immutable from 'seamless-immutable';
import { createSelector } from 'reselect';
import { normalize } from 'normalizr';

import firebase from '../firebase';
import schema from '../schema';

const ActionTypes = {
  RECEIVED_SNAPSHOT_DATA: 'RECEIVED_SNAPSHOT_DATA',
};

const getSnapshotsFromObj = (state, props) => state.entities.snapshots;

// THIS ISNT WORKING YET!!!!
const Selectors = {
  getStateChange: (state, props) =>
    createSelector(
      [getSnapshotsFromObj, getSnapshotsFromObj],
      (oldSnapshots, newSnapshots) => {
        console.log(
          'OLD SNAPSHOTS: ',
          oldSnapshots,
          ' NEW SNAPSHOTS => ',
          newSnapshots,
        );
        return 'HELLO WORLD';
      },
    ),
};

const Private = {
  ref: null,
  setRef: exchange => {
    Private.ref = firebase.database().ref(`snapshots/${exchange}`);
  },
};

const Actions = {
  creators: {
    dataSnapshots: data => ({
      data,
      type: ActionTypes.RECEIVED_SNAPSHOT_DATA,
    }),
  },
  thunks: {
    observeSnapshots: exchange => dispatch => {
      console.log('observing snapshots ', exchange);
      Private.setRef(exchange);
      // Observe
      Private.ref
        .once('value')
        .then(snapshot => {
          const data = normalize(snapshot.val(), schema.SNAPSHOTS);
          dispatch(Actions.creators.dataSnapshots(data));
        })
        .then(() => {
          // return;
          Private.ref.on('child_changed', snapshot => {
            const data = normalize(snapshot.val(), schema.SNAPSHOT);
            dispatch(Actions.creators.dataSnapshots(data));
          });
        });
    },
  },
  removeObserver: () => {
    if (Private.ref) {
      Private.ref.off();
      Private.ref = null;
    }
  },
};

export { Actions, Selectors };

const defaultState = Immutable({});
export default (state = defaultState, action) => {
  if (action.type === ActionTypes.RECEIVED_SNAPSHOT_DATA) {
    return state.merge(action.data.entities.snapshots);
  }
  return state;
};



// WEBPACK FOOTER //
// ./src/ducks/snapshots.js